import React from 'react';
import { Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import {FeatureItem} from '../../common/FeatureItem';
import CenteredSection from './CenteredSection';

const FeatureGridSection = () => {
    const { t } = useTranslation();

    return (
        <CenteredSection bg="light" className="text-center">
            <h2 className="mb-4">{t('pages.dmarcChecker.whyDmarc.title')}</h2>
            <p className="lead mb-5">{t('pages.dmarcChecker.whyDmarc.subTitle')}</p>
            <Row className="justify-content-center">
                {["one", "two", "three", "four", "five"].map((key, index) => (
                    <Col key={index} xs={12} md={6} className="mb-4">
                        <FeatureItem
                            title={t(`pages.dmarcChecker.whyDmarc.features.list.${key}.title`)}
                            description={t(`pages.dmarcChecker.whyDmarc.features.list.${key}.description`)}
                            iconClass={`bi bi-${key === 'one' ? 'inboxes-fill' : key === 'two' ? 'shield-x' : key === 'three' ? 'hdd-stack-fill' : key === 'four' ? 'globe-asia-australia' : 'ethernet'} text-primary`}
                        />
                    </Col>
                ))}
            </Row>
        </CenteredSection>
    );
};

export default FeatureGridSection;
